module.exports = __webpack_public_path__ + "static/media/graphics.b357d5fb.png";